import React from 'react';
import PropTypes from 'prop-types';
import { ModalBody, ModalHeader } from 'reactstrap';
import WindcreekModal from 'components/WindcreekModal';
import { PROPERTY_TERMS_AND_CONDITIONS_FULL } from 'utils/messages/termsAndConditions';
import styled from 'styled-components';

const StyledModal = styled(WindcreekModal)`
  .modal-content {
    text-align: left;
  }
`;

const propTypes = {
  property: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};

const defaultProps = {};

function TermsAndConditionsModal({ property, isOpen, toggle }) {
  const data = PROPERTY_TERMS_AND_CONDITIONS_FULL[property];

  if (!data) {
    return null;
  }

  return (
    <StyledModal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      centered
      autoFocus
      scrollable
    >
      <ModalHeader toggle={toggle}>Online Reservation Agreement</ModalHeader>
      <ModalBody>
        {Array.isArray(data) ? (
          <ol>
            {data.map(item => (
              <li>{item}</li>
            ))}
          </ol>
        ) : (
          <p>{data}</p>
        )}
      </ModalBody>
    </StyledModal>
  );
}

TermsAndConditionsModal.propTypes = propTypes;
TermsAndConditionsModal.defaultProps = defaultProps;

export default TermsAndConditionsModal;
